import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { RefElement } from '../../types';
import { withTestIds } from '../../utils';
import RadioCheckGroup from '../RadioCheckGroup';
import type { RadioCheckGroupProps } from '../RadioCheckGroup';
import { getRadioCheckGroupTestIds } from '../RadioCheckGroup/RadioCheckGroup.test-ids';

// Using Omit instead of OmitStrict as workaround for downstream consumers without inert type augmentation.
// eslint-disable-next-line @typescript-eslint/ban-types
export type RadioButtonGroupProps = Omit<RadioCheckGroupProps, 'arrowNavigation'>;

const RadioButtonGroup = forwardRef<
  RefElement<RadioButtonGroupProps>,
  PropsWithoutRef<RadioButtonGroupProps>
>(function RadioButtonGroup(props, ref) {
  return <RadioCheckGroup {...props} ref={ref} arrowNavigation />;
});

export default withTestIds(RadioButtonGroup, getRadioCheckGroupTestIds);
